<template>
  <div v-if="linkVerified">
    <div  class="my-auto text-white">
      <div class="text-center">
        <h3 class="mt-0 text-info mb-4">{{ $t('changepwd.title') }}</h3>
      </div>
      <form @submit.prevent="handleSubmit">
        <div class="mb-3">
          <PasswordComponent id="password" v-model="password" :label="$t('changepwd.newPassword')" />
        </div>
        <div class="mb-3">
          <PasswordComponent id="confirmed-password" v-model="confirmPassword" :label="$t('changepwd.confirmPassword')" />
        </div>
        <div class="d-grid mb-0 text-center">
          <button class="btn btn-info" type="submit">{{ $t('common.submit') }}</button>
        </div>
        <div v-if="errorMessage" class="mt-2 text-white">
          {{ errorMessage }}
        </div>
      </form>
    </div>
    <!-- Footer -->
    <footer class="footer footer-alt">
<p class="text-white">{{ $t('logout.backTo') }} <router-link to="/login" class="text-sidebar-link ms-1"><b>{{ $t('common.backToLogin') }}</b></router-link>
      </p>
    </footer>
  </div>
</template>

<script>
import { useUserStore } from '@/stores/userStore';
import { useRouter, useRoute } from 'vue-router';
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import PasswordComponent from '@/components/password';

export default {
  name: 'ChangePwdPage',
  components: {
    PasswordComponent
  },
  setup() {
    const userStore = useUserStore();
    const router = useRouter();
    const route = useRoute();
    const { t } = useI18n();
    const uuid = route.query.uuid;
    const type = route.query.type;
    const password = ref("");
    const confirmPassword = ref("");
    const errorMessage = ref("");
    const linkVerified = ref(false);

    onMounted( async () => {
      try {
          await userStore.checkUUID(uuid, `${type}_changepwd`);
          linkVerified.value = true;
      } catch (error) {
        router.push({ path: "/result", query: { success: false, title: t('common.failure'), message: error } });
      }
    });

    const handleSubmit = async () => {
      if (validate()) {
        try {
          const result = await userStore.changePassword(uuid, password.value, type);
          if (result == 'mfaNeeded') {
            router.push({ path: "/mfa", query: {uuid: uuid, type: type}});
          } else {
            router.push({ path: "/result", query: { success: true, title: t('common.done'), message: t('changepwd.passwordChanged') } });
          }
        } catch (error) {
          errorMessage.value = error;
        }
      }
    };

    const validate = () => {
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      if (!passwordRegex.test(password.value)) {
        displayError('password', t('common.passwordRequirements'));
        return false;
      }
      if (password.value != confirmPassword.value) {
        displayError('confirmed-password', t('common.passwordsMustMatch'));
        return false;
      }
      return true;
    };

    const displayError = (id, error) => {
      const input = document.getElementById(id);
      input.setCustomValidity(error);
      input.reportValidity();
    }

    return {
      password,
      confirmPassword,
      errorMessage,
      handleSubmit,
      linkVerified,
    };
  },
};
</script>
